import { Box, Flex, Input, Text, useToast } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { useRecoilState, useSetRecoilState } from 'recoil'
import socket from './socket'
import { modalState, userState } from './store'
import { dateToClock, numberWithCommas } from './utils'

export default function Chat() {
  const toast = useToast()
  const [message, setMessage] = useState('')
  const dummy = useRef()
  const [user, setUser] = useRecoilState(userState)
  const [chat, setChat] = useState([])
  const setModal = useSetRecoilState(modalState)

  useEffect(() => {
    socket.on('user-chat', data => {
      if (data.error) {
        return toast({
          title: data.error,
          status: 'error',
          duration: 9000,
          isClosable: true,
        })
      }
      setChat(prevChat => [...prevChat, data])
    })

    // socket.on('user-muted', data => {
    //   toast({
    //     title: `${data.username} has been muted.`,
    //     status: 'error',
    //     duration: 9000,
    //     isClosable: true,
    //   })
    // })

    socket.on('user-tip-send', data => {
      if (data.error) {
        toast({
          title: data.error,
          status: 'error',
          duration: 9000,
          isClosable: true,
        })
      } else {
        setUser(prevState => ({
          ...prevState,
          balance: prevState.balance - data.amount,
        }))
        toast({
          title: `You tipped ${numberWithCommas(data.amount)} XRP to ${
            data.recipient
          }.`,
          status: 'warning',
          duration: 9000,
          isClosable: true,
        })
      }
    })

    socket.on('app-init', ({ chat: chatMessages }) => {
      setChat(chatMessages)
    })

    return () => {
      socket.off('user-chat')
      socket.off('user-tip-send')
      socket.off('app-init')
    }
  }, [])

  useEffect(() => {
    dummy.current.scrollIntoView({ behavior: 'smooth' })
  }, [chat])

  const handleMessage = () => {
    if (!message) return
    socket.emit('user-chat', message)
    setMessage('')
  }

  return (
    <Flex h="100%" flexDir="column">
      <Box flex="1" overflowY="scroll" py="1">
        {chat.map(msg => {
          let rank
          let color = 'orange.400'
          if (msg.rank) {
            if (msg.rank === 5) {
              rank = 'Streamer'
              color = 'purple.400'
            } else if (msg.rank === 10) {
              rank = 'Mod'
              color = 'blue.400'
            } else if (msg.rank === 15) {
              rank = 'Youtuber'
              color = 'red.400'
            } else if (msg.rank === 100) {
              rank = 'Owner'
              color = 'red.500'
            }
          }

          return (
            <Text key={msg.id}>
              <Text as="span" fontSize="xs">
                {dateToClock(msg.sentAt)}
              </Text>{' '}
              <Text
                as="span"
                cursor="pointer"
                onClick={() => setModal(`user ${msg.username}`)}
                color={color}
              >
                {rank && `[${rank}]`} {msg.username}
              </Text>
              : {msg.message}
            </Text>
          )
        })}
        <Box ref={dummy}></Box>
      </Box>

      <Input
        variant="filled"
        placeholder={user.isLoggedIn ? 'Say something...' : 'Login to chat'}
        pr="3.5rem"
        disabled={!user.isLoggedIn}
        value={message}
        onChange={e => setMessage(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && handleMessage()}
      />
    </Flex>
  )
}
